import { makeObservable, observable, action } from 'mobx';

export type RunningHistoryType =
  | 'nonRunner'
  | 'longTimeAgo'
  | 'pastCoupleYears'
  | 'activeRunner';

export class RunningHistoryStore {
  selectedRunningHistory: RunningHistoryType | null = null;

  constructor() {
    makeObservable(this, {
      selectedRunningHistory: observable,
      setRunningHistory: action,
    });
  }

  setRunningHistory(inputRunningHistory: RunningHistoryType) {
    this.selectedRunningHistory = inputRunningHistory;
  }
}

export const genderStore = new RunningHistoryStore();
